import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

import type { ArgumentArray } from 'classnames';

/**
 * Merge Tailwind class lists so the LAST conflicting utility wins.
 *
 * Plain `classNames` keeps both `px-4` and `px-8`; which one applies then depends on CSS source
 * order, not on the caller's intent. `twMerge` drops the earlier one, which is what makes a
 * `className` prop able to override a recipe's own utilities.
 */
export const cn = (...inputs: ArgumentArray) => twMerge(classNames(inputs));
